<template>
	<b-modal :title="modalTitle" id="receipt-image-view" :no-close-on-backdrop="true" size="lg" ok-only
		ok-variant="primary" ok-title="Close" centered>
		<!-- Single Image View (for inactive node proof) -->
		<div v-if="isSingleImage">
			<b-row>
				<b-col sm="12">
					<div class="thumbnail text-center">
						<b-img v-img-orientation-changer :src="imageDetails.imageLink" alt="Proof of Receipt"
							class="img-responsive" fluid />
					</div>
				</b-col>
			</b-row>
		</div>

		<!-- Multiple Images View (for normal dispatch proof) -->
		<div v-else-if="images && images.length > 0">
			<!-- Current Image Display -->
			<b-row>
				<b-col cols="12" class="text-center">
					<img :src="currentImage.url" :alt="currentImage.name" class="proof-image" />
				</b-col>
			</b-row>

			<!-- Image Navigation -->
			<b-row class="mt-3" v-if="images.length > 1">
				<b-col cols="12" class="text-center">
					<b-button variant="outline-primary" size="sm" @click="previousImage" :disabled="currentIndex === 0">
						<i class="fa fa-chevron-left"></i> Previous
					</b-button>
					<span class="mx-3">{{ currentIndex + 1 }} of {{ images.length }}</span>
					<b-button variant="outline-primary" size="sm" @click="nextImage"
						:disabled="currentIndex === images.length - 1">
						Next <i class="fa fa-chevron-right"></i>
					</b-button>
				</b-col>
			</b-row>

			<!-- Image Thumbnails -->
			<b-row class="mt-3" v-if="images.length > 1">
				<b-col cols="12" class="d-flex justify-content-center flex-wrap">
					<div v-for="(image, index) in images" :key="index" class="thumbnail-wrapper"
						:class="{ active: index === currentIndex }" @click="selectImage(index)">
						<img :src="image.url" :alt="image.name" class="thumbnail-image" />
					</div>
				</b-col>
			</b-row>

			<!-- Image Details -->
			<b-row class="mt-3">
				<b-col cols="12">
					<p class="text-muted text-center">
						<small>{{ currentImage.name }}</small>
					</p>
				</b-col>
			</b-row>
		</div>

		<!-- No Images Available -->
		<div v-else class="text-center py-4">
			<p class="text-muted">No proof of receipt images available.</p>
		</div>
	</b-modal>
</template>

<script>
// Util
import { DateUtil } from '@/utils/dateutil';

// Others
import EventBus from '@/shared/event-bus';

export default {
	name: 'ProofReceiptImageView',
	data() {
		return {
			imageDetails: {}, // For single image (inactive node proof)
			images: [],       // For multiple images (normal dispatch proof)
			currentIndex: 0,
			dispatchId: ''
		}
	},
	computed: {
		dateApproved() {
			return DateUtil.getFormattedDateWithTime(this.imageDetails.dateApproved);
		},
		isSingleImage() {
			return this.imageDetails && this.imageDetails.imageLink;
		},
		currentImage() {
			if (this.images && this.images.length > 0) {
				return this.images[this.currentIndex];
			}
			return { url: '', name: '' };
		},
		modalTitle() {
			return `Dispatch ${this.dispatchId || this.imageDetails.dispatchId || ''}`;
		}
	},
	mounted() {
		// Legacy event for single image (inactive node proof)
		EventBus.$on('onUpdateSelProofReceiptImageView', imageDetails => {
			this.imageDetails = imageDetails;
			this.images = [];
			this.dispatchId = imageDetails.dispatchId || '';
		});

		// New event for multiple images (normal dispatch proof)
		EventBus.$on('onShowProofReceiptImages', (data) => {
			this.images = data.images || [];
			this.dispatchId = data.dispatchId || '';
			this.imageDetails = {};
			this.currentIndex = 0;
		});
	},
	methods: {
		previousImage() {
			if (this.currentIndex > 0) {
				this.currentIndex--;
			}
		},
		nextImage() {
			if (this.currentIndex < this.images.length - 1) {
				this.currentIndex++;
			}
		},
		selectImage(index) {
			this.currentIndex = index;
		}
	},
	beforeDestroy() {
		EventBus.$off('onUpdateSelProofReceiptImageView');
		EventBus.$off('onShowProofReceiptImages');
	}
}
</script>

<style scoped>
.thumbnail {
	position: relative;
}

.caption {
	position: absolute;
	bottom: 0px;
	left: -10px;
	width: 100%;
}

.strokeme {
	color: white;
	text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

/* Multiple images view styles */
.proof-image {
	max-width: 100%;
	max-height: 500px;
	border: 1px solid #ddd;
	border-radius: 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.thumbnail-wrapper {
	margin: 5px;
	padding: 3px;
	border: 2px solid transparent;
	border-radius: 4px;
	cursor: pointer;
	transition: border-color 0.2s;
}

.thumbnail-wrapper:hover {
	border-color: #20A8D8;
}

.thumbnail-wrapper.active {
	border-color: #20A8D8;
	background-color: #f0f8ff;
}

.thumbnail-image {
	width: 80px;
	height: 80px;
	object-fit: cover;
	border-radius: 4px;
}
</style>